import { URI_API, URI } from "../utils/api";
import useHeaders from "../utils/useHeaders";

const getAllUsers = async () => {
  return await fetch(`${URI_API}/user/all`, {
    method: "GET",
    headers: useHeaders.getHeaders(),
  }).then((res) => res.json());
};

const getAllAuthors = async () => {
  return await fetch(`${URI_API}/user/authors`, {
    method: "GET",
    headers: useHeaders.getHeaders(),
  })
    .then((res) => res.json())
    .then((res) => eval(res));
};

const getUsersPerHospital = async (hospitals: any[]) => {
  const hospitalNames = hospitals.map((hospital: any) => hospital.name);
  return await fetch(`${URI_API}/user/all/per_hospitals`, {
    method: "POST",
    body: JSON.stringify(hospitalNames),
    headers: useHeaders.getHeaders(),
  }).then((res) => res.json());
};

const loginUser = async (body: any) => {
  return await fetch(`${URI}/token`, {
    method: "POST",
    body: body,
  }).then((res) => res.json());
};

const userExists = async (email: any) => {
  return await fetch(`${URI_API}/user/user_exists`, {
    method: "POST",
    headers: useHeaders.getHeaders(),
    body: JSON.stringify(email)
  }).then((res) => res.json());
};

const createUser = async (user: any) => {
  return await fetch(`${URI_API}/user/create`, {
    method: "POST",
    headers: useHeaders.getHeaders(),
    body: JSON.stringify(user),
  }).then((res) => res.json());
};

const getUserLogged = async () => {
  return await fetch(`${URI_API}/user/me`, {
    method: "GET",
    headers: useHeaders.getHeaders(),
  }).then((res) => res.json());
};

export default {
  getAllUsers,
  loginUser,
  getUserLogged,
  getAllAuthors,
  userExists,
  createUser,
  getUsersPerHospital,
};
